<div style="position: relative; width: 100%; max-width: 400px; margin: 0 auto;">
    <input *ngIf="!imageSrc" type="file" (change)="fileChangeEvent($event)" />

    <image-cropper [imageChangedEvent]="imageChangedEvent" [imageBase64]="imageSrc ? imageSrc : null"
        [maintainAspectRatio]="true" [aspectRatio]="4 / 3" format="png" (imageCropped)="onImageCropped($event)"
        (imageLoaded)="onImageLoaded()" (cropperReady)="onCropperReady()" (loadImageFailed)="onLoadImageFailed()">
    </image-cropper>

    <img [src]="croppedImage" />
    {{croppedImage}}
</div>
<div class="d-flex justify-content-between mt-2">
    <button class="my-button-3" (click)="resetCrop()">
        <i class="fa-solid fa-rotate-left"></i> Reset
    </button>
    <button class="my-button-3" (click)="saveCrop()">
        <i class="fa-solid fa-scissors"></i> Crop & Save
    </button>
</div>